<template>
  <div class="h-100">
    <Layout ref="layout">
      <template v-slot:body>
        <Tab
          :values="[
            { name: 'Urbana', slot: 'urbana' },
            { name: 'Rural', slot: 'rural' },
          ]"
          @tabchange="forceRerenderTab"
          ref="tab"
        >
          <template v-slot:urbana>
            <Crud
              :modal="false"
              @delete="$refs.datatable.update()"
              name="Propriedade"
              names="Propriedades"
              @filter="$refs.datatable.applyFilters($event)"
              :btnfilter="false"
              button="+"
              @oncreate="oncreate"
              @onupdate="onupdate"
              @onformcreate="onformcreate"
              url="/PropriedadeAgricola"
              :iniorderby="{ column: 'created', type: 'DESC' }"
              :is-tab="true"
            >
              <template v-slot:list="form">
                <Datatable
                  v-if="tabComponent"
                  ref="datatable"
                  :fields="fields"
                  :fieldsMobile="fieldsMobile"
                  url="/PropriedadeAgricola/ReadUrban"
                  @edit="openEdit(form, $event)"
                  @delete="form.crud.delete($event)"
                  :where="where"
                  :mobileCardMode="true"
                >
                </Datatable>
              </template>
              <template v-slot:form="form">
                <PropriedadeAgricolaForm ref="urbanForm" :form="form" />
              </template>
              <template v-slot:filter="data">
                <div>
                  <div class="mb-3">
                    <label class="form-label">Nome</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="data.filters.nome"
                    />
                  </div>
                </div>
              </template>
            </Crud>
          </template>
          <template v-slot:rural>
            <Crud
              :modal="false"
              :big-modal="true"
              @delete="$refs.datatable.update()"
              name="Propriedade"
              names="Propriedades"
              @filter="$refs.datatable.applyFilters($event)"
              :btnfilter="false"
              button="+"
              @oncreate="oncreate"
              @onupdate="onupdate"
              @onformcreate="onformcreate"
              url="/PropriedadeAgricola"
              :iniorderby="{ column: 'created', type: 'DESC' }"
              :is-tab="true"
            >
              <template v-slot:list="form">
                <Datatable
                  v-if="tabComponent"
                  ref="datatable"
                  :fields="fields"
                  :fieldsMobile="fieldsMobile"
                  url="/PropriedadeAgricola/ReadRural"
                  @edit="openEdit(form, $event)"
                  @delete="form.crud.delete($event)"
                  :where="where"
                  :mobileCardMode="true"
                >
                </Datatable>
              </template>
              <template v-slot:form="form">
                <PropriedadeAgricolaForm ref="ruralForm" :form="form" />
              </template>
              <template v-slot:filter="data">
                <div>
                  <div class="mb-3">
                    <label class="form-label">Nome</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="data.filters.nome"
                    />
                  </div>
                </div>
              </template>
            </Crud>
          </template>
        </Tab>
      </template>
    </Layout>
    <Alert ref="alert"></Alert>
  </div>
</template>

<script>
import Crud from "../../components/crud/Crud.vue";
import Datatable from "../../components/crud/Datatable.vue";
import Layout from "../../components/layout/Tema.vue";
import Alert from "../../components/Alert.vue";
import Tab from "../../components/form/Tab.vue";
import { mask } from "vue-the-mask";
import PropriedadeAgricolaForm from "../../components/form/PropriedadeAgricolaForm.vue";

export default {
  directives: { mask },
  components: {
    Crud,
    Layout,
    Tab,
    Datatable,
    Alert,
    PropriedadeAgricolaForm,
  },

  data() {
    return {
      tabComponent: true,
      fields: [
        { name: "Nome", value: "nome", style: { width: "100px" } },
        {
          name: "Endereço",
          value: "logradouro",
          style: { textAlign: "center" },
        },
        {
          name: "Ação",
          type: "action",
          orderby: false,
          value: "status",
          edit: true,
          delete: false,
          style: { width: "100px", minWidth: "100px", textAlign: "center" },
        },
      ],
      fieldsMobile: [
        { name: "Nome / Endereço", value: ["nome", "logradouro"] },
        {
          name: "Ação",
          type: "action",
          orderby: false,
          value: "status",
          edit: true,
          delete: false,
        },
      ],
      where: {
        nome: {
          operator: "LIKE",
          replace: "%{value}%",
        },
      },
    };
  },
  methods: {
    forceRerenderTab() {
      this.tabComponent = false;
      this.$nextTick(() => {
        this.tabComponent = true;
      });
    },
    onformcreate(form) {
      form.culturaPropriedades = [];
      form.locais = [];
      if (!form.propriedade) {
        // Detectar qual aba está ativa para definir o tipo correto
        const activeTab = this.$refs.tab?.activeSlot || 'urbana';
        form.propriedade = activeTab === 'rural' ? 'Rural' : 'Urbano';
      }
    },
    openEdit(form, data) {
      if (data.culturaPropriedades == null) {
        data.culturaPropriedades = [];
      }

      // Transformar localId (estrutura antiga) em locais (array)
      if (data.locais && Array.isArray(data.locais)) {
        // Já tem locais, só garantir que está ok
      } else if (data.localId && !data.locais) {
        data.locais = [data.localId];
        delete data.localId;
      } else {
        data.locais = [];
      }

      // IMPORTANTE: Chamar edit DEPOIS de configurar os dados
      form.crud.edit(data);

      // Garantir que locais esteja atribuído após o edit
      this.$nextTick(() => {
        if (data.locais && data.locais.length > 0) {
          // Forçar atualização criando nova referência
          form.crud.form.locais = JSON.parse(JSON.stringify(data.locais));

          // Forçar atualização do MultipleLocationsManager
          this.$nextTick(() => {
            const formRef = data.propriedade === 'Urbano' || data.tipoPropriedade === 'Urbano' ? this.$refs.urbanForm : this.$refs.ruralForm;
            if (formRef && formRef.forceLocationsUpdate) {
              formRef.forceLocationsUpdate(data.locais);
            }
          });
        }
      });
    },
    oncreate(form) {
      // Validar pins antes de criar
      const formRef = form.propriedade === 'Urbano' ? this.$refs.urbanForm : this.$refs.ruralForm;
      if (formRef && formRef.validateBeforeSave) {
        if (!formRef.validateBeforeSave()) {
          // Lançar erro vazio para cancelar sem mostrar alert duplicado
          const err = new Error();
          err.message = ''; // Mensagem vazia para não mostrar alert
          throw err;
        }
      }

      // Limpar campos opcionais vazios
      if (!form.tipoIdentificacao || form.tipoIdentificacao === '') {
        form.tipoIdentificacao = null;
      }
      if (!form.identificacao || form.identificacao === '') {
        form.identificacao = null;
      }
      if (!form.tipoOrganizacao || form.tipoOrganizacao === '') {
        form.tipoOrganizacao = null;
      }

      if (form.expire == 0) {
        form.expire = null;
        return;
      }
      var expire = new Date();
      expire.setDate(expire.getDate() + form.expire);
      form.expire = expire;
    },
    onupdate(form) {
      // Validar pins antes de atualizar
      const formRef = form.propriedade === 'Urbano' ? this.$refs.urbanForm : this.$refs.ruralForm;
      if (formRef && formRef.validateBeforeSave) {
        if (!formRef.validateBeforeSave()) {
          // Lançar erro vazio para cancelar sem mostrar alert duplicado
          const err = new Error();
          err.message = ''; // Mensagem vazia para não mostrar alert
          throw err;
        }
      }

      // Limpar campos opcionais vazios
      if (!form.tipoIdentificacao || form.tipoIdentificacao === '') {
        form.tipoIdentificacao = null;
      }
      if (!form.identificacao || form.identificacao === '') {
        form.identificacao = null;
      }
      if (!form.tipoOrganizacao || form.tipoOrganizacao === '') {
        form.tipoOrganizacao = null;
      }
    },
    clearProperty(form) {
      form.crud.form.culturaPropriedades = [];
    },
    clearTypeOrganization(form) {
      form.crud.form.tipoOrganizacao = null;
    },
    abrirModalAplicativo() {
      $(this.$refs.modal_aplicativo).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    fecharModalAplicativo() {
      $(this.$refs.modal_aplicativo).modal("hide");
    },
    abrirModalFinalizar(data) {
      $(this.$refs.modal_finalizar).modal({
        backdrop: "static",
        keyboard: false,
      });
      this.id = data;
    },
    fecharModalFinalizar() {
      $(this.$refs.modal_finalizar).modal("hide");
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"/>
<style>
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  transition: all 0.3s;
}
.switch::after {
  content: "";
  position: absolute;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: white;
  top: 1px;
  left: 1px;
  transition: all 0.3s;
}

.checkbox:checked + .switch::after {
  left: 20px;
}
.checkbox:checked + .switch {
  background-color: #006035;
}
.checkbox {
  display: none;
}
</style>